import { render, staticRenderFns } from "./djintegral.vue?vue&type=template&id=961287ba&"
import script from "./djintegral.vue?vue&type=script&lang=js&"
export * from "./djintegral.vue?vue&type=script&lang=js&"
import style0 from "./djintegral.vue?vue&type=style&index=0&id=961287ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports